/* eslint-disable array-callback-return */
/* eslint-disable function-paren-newline */
/* eslint-disable implicit-arrow-linebreak */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Icon,
  Modal,
  ModalFooter,
  Checkbox,
  Row,
  Col,
} from '@folio/stripes-components';
import { FormattedMessage } from 'react-intl';
import { FaEdit } from 'react-icons/fa';
import { Form } from 'react-final-form';
import arrayMutators from 'final-form-arrays';
import { filter, map, remove } from 'lodash';
import FormFieldsGenerator from '../../../../../../../shared/FormFieldsGenerator';

function BatchEditHoldingsModal({
  onClose,
  isOpen,
  template,
  controlledVocab,
  selectedHoldings,
  holdingsData,
  onConfirm,
  itemsFields,
  onUpdateItems,
}) {
  const [updateItemsLocations, setUpdateItemsLocations] = useState(false);
  // Filter template fields to make all fields non-required (similar to items modal)
  const filteredTemplate = template?.templateFields?.holdings?.map((field) => {
    return {
      ...field,
      sectionFields: field.sectionFields.map((mappedField) => ({
        ...mappedField,
        isRequired: false
      })),
    };
  });

  const renderFooter = (handleSubmit, pristine, submitting) => {
    return (
      <ModalFooter>
        <Button
          id="edit-batch-holdings-modal-btn"
          buttonStyle="primary"
          type="submit"
          onClick={(event) => {
            handleSubmit(event);
            onClose();
          }}
          disabled={pristine || submitting}
        >
          <FormattedMessage
            id="ui-plugin-inventory-templates.buttons.editBatchHoldings"
            defaultMessage="Edit batch holdings"
          />
        </Button>
        <Button id="edit-batch-holdings-modal-cancel-btn" onClick={onClose}>
          <FormattedMessage
            id="ui-plugin-inventory-templates.buttons.cancel"
            defaultMessage="Cancel"
          />
        </Button>
      </ModalFooter>
    );
  };

  const onHandleSubmit = (values, form) => {
    console.log('Batch edit holdings values: ', values);

    // Apply changes to each selected holding - similar to items modal approach
    const updatedHoldings = [...holdingsData];

    selectedHoldings.map((holdingId) => {
      const holdingIndex = updatedHoldings.findIndex(
        (holding) => holding.id === holdingId,
      );

      if (holdingIndex !== -1) {
        const currentHolding = updatedHoldings[holdingIndex];
        // Update the holding with new values
        updatedHoldings[holdingIndex] = {
          ...currentHolding,
          ...values,
        };
      }
    });

    // Send all updated holdings back
    onConfirm(updatedHoldings, updateItemsLocations, values);
    form.reset();
  };

  return (
    <Form
      onSubmit={onHandleSubmit}
      initialValues={{ holdingDiscoverySuppress: false }} // Start with initial value to make form not pristine
      mutators={{
        ...arrayMutators,
      }}
      subscription={{ handleSubmit: true, pristine: true, submitting: true }}
    >
      {({ handleSubmit, pristine, submitting }) => {
        return (
          <Modal
            id="edit-batch-holdings-modal"
            open={isOpen}
            onClose={onClose}
            footer={renderFooter(handleSubmit, pristine, submitting)}
            wrappingElement="form"
            label={
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '7px',
                }}
              >
                <FaEdit size={18} />
                <FormattedMessage
                  id="ui-plugin-inventory-templates.editBatchHoldingsModal.label"
                  defaultMessage="Edit batch holdings"
                />
              </div>
            }
            size="large"
          >
            <form id="edit-holdings-batch-form" onSubmit={handleSubmit}>
              {/* Option to update items locations */}
              {itemsFields?.value?.length > 0 && (
                <Row>
                  <Col xs={12}>
                    <div style={{ 
                      padding: '12px', 
                      backgroundColor: '#f8f9fa', 
                      border: '1px solid #dee2e6', 
                      borderRadius: '4px', 
                      marginBottom: '20px' 
                    }}>
                      <Checkbox
                        checked={updateItemsLocations}
                        onChange={(e) => setUpdateItemsLocations(e.target.checked)}
                        label={
                          <FormattedMessage
                            id="ui-plugin-inventory-templates.holdingManagement.batchEditModal.updateItemsLocations"
                            defaultMessage="Update items locations to match holdings locations"
                          />
                        }
                        onMouseDown={(e) => e.preventDefault()}
                      />
                      <div style={{ fontSize: '12px', color: '#6c757d', marginTop: '4px' }}>
                        <FormattedMessage
                          id="ui-plugin-inventory-templates.holdingManagement.batchEditModal.updateItemsLocations.description"
                          values={{ 
                            holdingsCount: selectedHoldings.length,
                            itemsCount: itemsFields.value.filter(item => 
                              selectedHoldings.includes(item.holdingsRecordId)
                            ).length 
                          }}
                          defaultMessage="This will update locations of {itemsCount} items belonging to {holdingsCount} selected holdings"
                        />
                      </div>
                    </div>
                  </Col>
                </Row>
              )}

              {/* Generate form fields based on template */}
              {filteredTemplate && (
                <FormFieldsGenerator
                  key="edit-holdings-batch"
                  formValues={filteredTemplate}
                  controlledVocab={controlledVocab}
                />
              )}
            </form>
          </Modal>
        );
      }}
    </Form>
  );
}

BatchEditHoldingsModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  template: PropTypes.object,
  controlledVocab: PropTypes.object,
  selectedHoldings: PropTypes.arrayOf(PropTypes.string),
  holdingsData: PropTypes.array,
  onConfirm: PropTypes.func,
  itemsFields: PropTypes.object,
  onUpdateItems: PropTypes.func,
};

export default BatchEditHoldingsModal;
